import * as React from "react"
import { useEditorState } from "@tiptap/react"
import { Button } from "../../tiptap-ui-primitive/button"
import { useTiptapEditor } from "../../hooks/use-tiptap-editor"

type Level = 1 | 2 | 3 | 4 | 5 | 6

export interface HeadingDropdownMenuProps {
  levels?: Level[]
  portal?: boolean
}

export const HeadingDropdownMenu: React.FC<HeadingDropdownMenuProps> = ({ 
  levels = [1, 2, 3, 4] 
}) => {
  const editor = useTiptapEditor()
  const [isOpen, setIsOpen] = React.useState(false)
  // Сохраняем позицию селекции при открытии
  const savedSelectionRef = React.useRef<{ from: number; to: number } | null>(null)

  const state = useEditorState({
    editor,
    selector: (ctx) => {
      const activeLevel = levels.find((level) => ctx.editor?.isActive("heading", { level }))
      return {
        activeLevel,
        isParagraph: ctx.editor?.isActive("paragraph") ?? false,
      }
    },
  })

  const handleOpen = () => {
    // Сохраняем текущую селекцию
    if (editor) {
      const { from, to } = editor.state.selection
      savedSelectionRef.current = { from, to }
    }
    setIsOpen(!isOpen)
  }

  const handleSelect = (level: Level | null) => {
    if (!editor) return
    
    // Восстанавливаем селекцию
    if (savedSelectionRef.current) {
      const { from, to } = savedSelectionRef.current
      editor.chain().setTextSelection({ from, to }).run()
    }
    
    if (level === null) {
      editor.chain().focus().setParagraph().run()
    } else {
      editor.chain().focus().toggleHeading({ level }).run()
    }
    setIsOpen(false)
    savedSelectionRef.current = null
  }

  const currentLabel = state.activeLevel ? `H${state.activeLevel}` : "P"

  return (
    <div style={{ position: "relative" }}>
      <Button onClick={handleOpen} aria-label="Заголовок">
        {currentLabel}
        <span style={{ marginLeft: 4 }}>▼</span>
      </Button>
      {isOpen && (
        <div style={{
          position: "absolute",
          top: "100%",
          left: 0,
          background: "var(--tt-bg-color, white)",
          border: "1px solid var(--tt-border-color, #e5e5e5)",
          borderRadius: 4,
          zIndex: 100,
          minWidth: 80,
        }}>
          <Button 
            onClick={() => handleSelect(null)} 
            data-active={state.isParagraph}
            style={{ width: "100%", justifyContent: "flex-start" }}
          >
            Параграф
          </Button>
          {levels.map((level) => (
            <Button 
              key={level} 
              onClick={() => handleSelect(level)}
              data-active={state.activeLevel === level}
              style={{ width: "100%", justifyContent: "flex-start" }}
            >
              Заголовок {level}
            </Button>
          ))}
        </div>
      )}
    </div>
  )
}
